import { generateFilePath } from '@/features/documents/api/upload-documents';
import { supabase } from '@/lib/supabase';
import { ProjectDocument, ProjectDocumentUpdateDto } from '@/shared/types/api';

export const updateDocument = async ({
  updateDto,
  kpiId,
  shouldUpdatePath,
  oldPath,
}: {
  updateDto: ProjectDocumentUpdateDto;
  kpiId?: string | null;
  shouldUpdatePath: boolean;
  oldPath?: string | undefined;
}): Promise<ProjectDocument> => {
  if (updateDto.id === undefined) {
    throw new Error('Id must be defined');
  }

  if (shouldUpdatePath && oldPath) {
    const newPath = generateFilePath({
      orgId: updateDto.org_id,
      project: updateDto.project_id,
      userId: updateDto.creator_id,
      fileName: oldPath.split('/').pop(),
      visibility: updateDto.visibility,
    });
    const { error: updateStorageError } = await supabase.storage
      .from('documents')
      .move(oldPath, newPath);
    updateDto.file_path = newPath;

    if (updateStorageError) {
      throw updateStorageError;
    }
  }

  const { data, error } = await supabase
    .from('project_documents')
    .update(updateDto)
    .eq('id', updateDto!.id)
    .select()
    .single();

  if (kpiId) {
    //TODO update kpi reference
    //TODO check if refrence exists and update to new kpiId
  }

  if (error) {
    throw error;
  }

  return data;
};
